/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

    // a11y (2026-06-14): Flickity marks off-screen slides aria-hidden but leaves their
    // links/buttons focusable, which fails Lighthouse "aria-hidden-focus". Keep focusables
    // inside hidden slides out of the tab order; restore them when their slide becomes active.
    var slideshowRoot = $slideshowClassicEl[0];
    function manageSlideFocus() {
      if (!slideshowRoot) return;
      var focusables = slideshowRoot.querySelectorAll('a[href],button,input,select,textarea,iframe,[tabindex]');
      Array.prototype.forEach.call(focusables, function(el) {
        var inHidden = el.closest('[aria-hidden="true"]');
        if (inHidden) {
          if (el.getAttribute('data-a11y-tab') === null) {
            el.setAttribute('data-a11y-tab', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
          }
          el.setAttribute('tabindex', '-1');
        } else if (el.getAttribute('data-a11y-tab') !== null) {
          var t = el.getAttribute('data-a11y-tab');
          if (t === 'none') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', t); }
          el.removeAttribute('data-a11y-tab');
        }
      });
    }
    $slideshowClassicEl.on('select.flickity settle.flickity ready.flickity', manageSlideFocus);
    setTimeout(manageSlideFocus, 150);

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;